/**
 * Custom Progress
 * 
 * @Author: Focci
 * @Date: 2023-04-28 09:09:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-04-28 09:09:56
 */

'use client'

import NProgress from 'nprogress'
import useRouterChange from '@hook/useRouterChange'
import '@pub/css/nprogress.css'

export default function CustomPregress() {
  useRouterChange(
    () => NProgress.start(),
    () => NProgress.done()
  )

  return (
    <>
    </>
  )
}
